module.exports = __webpack_public_path__ + "static/img/SearchDetailLogout1.9b88520.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailLogout1.png
// module id = 737
// module chunks = 0